<template>
	<div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
		<div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
			<vx-card>
				<div slot="no-body" class="full-page-bg-color">
					<div class="vx-row no-gutter justify-center items-center">
						<div class="vx-col hidden lg:block lg:w-1/2">
							<img src="@/assets/images/pages/forgot-password.png" alt="login" class="mx-auto">
						</div>
						<div class="vx-col sm:w-1/2 md:w-1/2 lg:w-1/2 d-theme-dark-bg">
							<div class="p-8 login-tabs-container">
								<div class="vx-card__title mb-4">
									<h4 class="mb-4">Wachtwoord vergeten</h4>
									<p>Je ontvangt een email van ons met instructies om je wachtwoord te herstellen.</p>
									<vs-alert color="success" :active.sync="emailSend">
										Als je e-mailadres bij ons bekend is hebben wij je een email gestuurd.
									</vs-alert>
									<vs-alert color="danger" :active.sync="emailNotSend">
										Het versturen van de email is mislukt, probeer het opnieuw.
									</vs-alert>
								</div>
								<div>
									<vs-input
										name="email"
										icon-no-border
										icon="icon icon-user"
										icon-pack="feather"
										label="Email"
										v-model="email"
										class="w-full" v-validate="'required|email'" />
									<span class="text-danger text-sm" v-show="errors.has('email')">{{
											errors.first('email')
										}}</span>
									<br>
									<router-link to="login">
										<vs-button type="border">Terug naar login</vs-button>
									</router-link>
									<vs-button @click.native="validate()" type="relief" class="float-right">E-mail
										versturen
									</vs-button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</vx-card>
		</div>
	</div>
</template>

<script>
import {mapActions} from 'vuex';
import Vue from 'vue';
import VeeValidate from 'vee-validate'
import {Validator} from 'vee-validate';

Vue.use(VeeValidate);
const dict = {
	custom: {
		email: {
			required: 'Voer alsjeblieft je e-mailadres in',
			email: 'Voer alsjeblieft een geldig e-mailadres in'
		},
	}
};
Validator.localize('en', dict);
export default {
	data() {
		return {
			loading: false,
			email: '',
			emailSend: false,
			emailNotSend: false,
		};
	},
	methods: {
		...mapActions({
			sendMail: 'userStore/sendPasswordForgetMail'
		}),
		validate() {
			this.$validator.validateAll().then(result => {
				if (result) {
					this.sendMail(this.email).then(res => {
						this.emailNotSend = false;
						this.emailSend = true;
					}).catch(err => {
						this.emailSend = false;
						this.emailNotSend = true;
					})
				}
			})
		},
	}
}
</script>

<style lang="scss">
#page-login {
	.social-login-buttons {
		.bg-facebook {
			background-color: #1551b1
		}

		.bg-twitter {
			background-color: #00aaff
		}

		.bg-google {
			background-color: #4285F4
		}

		.bg-github {
			background-color: #333
		}
	}
}
</style>
